import { StyleSheet } from 'react-native';

import { responsiveHeight } from '@/hooks/useResponsiveDimensions';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Diktat } from './diktat';
import { Gap } from './gap';

export function WritingTextExercise({
  skip,
  settings,
  currentExercise,
  exercise,
  checkProgress,
  isSelf,
}) {
  const { textContent, textNormalAudioURL, textTitle } = exercise;
  const { setting, playbackRate } = settings;
  const isGap = setting == 'gap';
  return (
    <SafeAreaView style={styles.container}>
      {isGap ? (
        <Gap
          checkProgress={checkProgress}
          currentExercise={currentExercise}
          skip={skip}
          textContent={textContent}
        />
      ) : (
        <Diktat
          checkProgress={checkProgress}
          playbackRate={playbackRate}
          textContent={textContent}
          textNormalAudioURL={textNormalAudioURL}
          textTitle={textTitle}
          currentExercise={currentExercise}
          uniqueKey={exercise?.uniqueExercisePrepareDate ?? null}
          skip={skip}
          isSelf={isSelf}
        />
      )}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginTop: responsiveHeight(2),
    justifyContent: 'center',
    alignItems: 'center',
  },
});
